// extracted by mini-css-extract-plugin
export var closeButton = "_3z-3";
export var header = "_3z-0";
export var link = "_3z-1";
export var retryButton = "_3z-2";